exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".agbContainer{ font-weight: 300; font-size: var(--small);\n    /* background-color: hsl(0, 0%, 90%); */\n    margin: 0;\n    padding: 39px;\n    /* padding: 20px; */\n    /*font-size: var(--agb_font_size);*/\n    color: hsl(0, 0%, 61%);\n    display: block;\n    /* border-top: 1px solid #c6c6c6;\n    position: fixed; */\n    bottom: 0;\n    text-align: left;\n}\n\na{\n    text-decoration: none;\n    color: #137cb9;\n    font-weight: 500;\n}\n\n\n@media (min-aspect-ratio: 4/3) {\n    .agbContainer{ font-weight: 300; font-size: var(--small);\n        /* width: 760px; */\n    }\n\n}", ""]);

// exports
